import { useCallback, useContext, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';
import { UserContext } from '../../context';
import { StoryCardStatus } from '../../services';
import { getTagsFeed, loadMoreTagsFeed } from '../../slices';
import { TAGS_FEED_ADMIN_COOKIE_KEY } from '../constants';
import { isAdminLayout } from '../utils';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { useLastDate } from './useLastDate';

export const useTagsFeed = () => {
  const dispatch = useAppDispatch();

  const { getDateRange } = useLastDate();

  const [cookies] = useCookies([TAGS_FEED_ADMIN_COOKIE_KEY]);

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { page } = useAppSelector(({ tagsFeed }) => tagsFeed);

  const organisationTagId = Number(useParams().organisationTagId);

  const { requestFilter = {} } = { ...cookies[TAGS_FEED_ADMIN_COOKIE_KEY] };

  const { dateRange, ...requestFilterRest } = requestFilter;

  const filters = useMemo(() => {
    if (!isAdminLayout()) {
      return { status: [StoryCardStatus.PUBLISHED] };
    }

    return { ...requestFilterRest, ...getDateRange(dateRange) };
  }, [dateRange, getDateRange, requestFilterRest]);

  const getTagsFeedItems = useCallback(
    () => dispatch(getTagsFeed({ channelId, organisationTagId, filters })),
    [channelId, dispatch, filters, organisationTagId]
  );

  const loadMoreTagsFeedItems = useCallback(
    () => dispatch(loadMoreTagsFeed({ channelId, organisationTagId, page: page + 1, filters })),
    [channelId, dispatch, filters, organisationTagId, page]
  );

  return { getTagsFeedItems, loadMoreTagsFeedItems };
};
